// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSRegisteredProcess/index.less
// module id = 942
// module chunks = 42